import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

export default function BillingCancel() {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "var(--ink-1)" }} data-testid="billing-cancel-page">
      <header className="border-b border-[var(--ink-border)]">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <Logo size="md" variant="lockup" linkTo="/" dark />
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-md w-full rounded-2xl ink-card p-8 text-center">
          <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center bg-white/5">
            <XCircle className="h-9 w-9 text-white/70" />
          </div>
          <h2 className="font-display font-black text-2xl text-white mt-5">Checkout cancelled</h2>
          <p className="text-sm text-white/60 mt-2">No charge was made. You can come back any time.</p>
          <Link to="/pricing">
            <Button className="w-full mt-7 text-white font-bold rounded-full py-6 red-glow" style={{ backgroundColor: "var(--brand-secondary)" }} data-testid="cancel-back-pricing">
              <ArrowLeft className="h-4 w-4 mr-2" /> Back to pricing
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
